// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__30N9h","label":"LabeledBox_label__1PE-K"};